<template>
    <div style="display: flex;align-items: center;">
      <div @click="openStartPicker">
        <el-input
            style="width: 150px"
            placeholder="2018-01-01"
            prefix-icon="el-icon-date"
            readonly
            :value="accu_start_end_date_dynamic[0].value"
        >
        </el-input>
      </div>
      <!-- 真正的date-picker隐藏在后面-->
      <el-date-picker
          class="date_style"
          ref="startDatePicker"
          style="width: 150px"
          v-model="accu_start_end_date[0]"
          align="center"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="2018-01-01"
          :picker-options="pickerOptionsStart"
      >
      </el-date-picker>

      <div style="padding: 0 8px;font-size: 14px;opacity: .6;">至</div>

      <div @click="openEndPicker">
        <el-input
            style="width: 150px"
            placeholder="今天"
            prefix-icon="el-icon-date"
            readonly
            :value="accu_start_end_date_dynamic[1].value"
        >
        </el-input>
      </div>
      <!-- 真正的date-picker隐藏在后面-->
      <el-date-picker
          class="date_style"
          ref="endDatePicker"
          style="width: 150px"
          v-model="accu_start_end_date[1]"
          align="center"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="今天"
          :picker-options="pickerOptionsEnd"
      >
      </el-date-picker>
    </div>
</template>

<script>
import {
  getLastMonthEndDate,
  getLastMonthStartDate, getLastQuarterEndDate,
  getLastQuarterStartDate, getLastWeekEndDate,
  getLastWeekStartDate, getLastYearEndDate,
  getLastYearStartDate, getMonthEndDate, getMonthStartDate, getQuarterEndDate, getQuarterStartDate, getWeekEndDate,
  getWeekStartDate, getYearEndDate, getYearStartDate
} from "@/utils/util";

export default {
  name: "CustomDateAreaPicker",
  props:['defaultStart','defaultEnd'],
  data(){
    return {
      //时间选择
      accu_start_end_date: [this.defaultStart,this.defaultEnd],
      accu_start_end_date_dynamic: [
        {
          key: 'monthStart',
          value: this.defaultStart,
          date: this.defaultStart
        }, {
          key: 'normal',
          value: this.defaultEnd,
          date: this.defaultEnd
        }],
      lastSelectDates: [{
        key: 'monthStart',
        value: this.defaultStart,
        date: this.defaultStart
      }, {
        key: 'normal',
        value: this.defaultEnd,
        date: this.defaultEnd
      }],
      accu_start_end_date_dynamic_init: [
        {
          key: 'normal',
          value: '',
          date: ''
        }, {
          key: 'normal',
          value: '',
          date: ''
        }],
      isShortCut: [false, false],//是否捷径中选择
      pickerOptionsStart:{},
      pickerOptionsEnd:{},
    }
  },
  created() {
    let that = this
    this.pickerOptionsStart = {
      //禁用今天往后的日期
      disabledDate(time) {
        // console.log('new Date(\'2021-01-01\')',new Date('2021-01-01'))
        return time.getTime() + 86400*1000 < new Date('2021-01-01')

      },
      shortcuts: [{
        text: '上周第一天',
        onClick(picker) {
          //如果点击前后日期相同，不会触发日期的update函数
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getLastWeekStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'lastWeekStart',
            value: '上周一',
            date: getLastWeekStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }


          // that.findSelsectChanged('shortCut')
          //+new Date().format('yyyy-mm-dd')
          picker.$emit('pick', getLastWeekStartDate());
        }
      }, {
        text: '上月第一天',
        onClick(picker) {
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getLastMonthStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'lastMonthStart',
            value: '上月第一天',
            date: getLastMonthStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          // that.findSelsectChanged('shortCut')
          picker.$emit('pick', getLastMonthStartDate());
        }
      }, {
        text: '上季第一天',
        onClick(picker) {
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getLastQuarterStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'lastQuarterStart',
            value: '上季第一天',
            date: getLastQuarterStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          // that.findSelsectChanged('shortCut')
          picker.$emit('pick', getLastQuarterStartDate());
        }
      }, {
        text: '上年第一天',
        onClick(picker) {
          that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getLastYearStartDate().format('yyyy-MM-dd') ? false : true
          that.accu_start_end_date_dynamic[0] = {
            key: 'lastYearStart',
            value: '上年第一天',
            date: getLastYearStartDate().format('yyyy-MM-dd')
          }
          that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
          if (that.isShortCut[0] == false) {
            that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
          }

          // that.findSelsectChanged('shortCut')
          picker.$emit('pick', getLastYearStartDate());
        }
      }
        ,{
          text: '本周第一天',
          onClick(picker) {
            that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getWeekStartDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[0] = {
              key: 'weekStart',
              value: '本周第一天',
              date: getWeekStartDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[0] == false) {
              that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
            }

            // that.findSelsectChanged('shortCut')
            picker.$emit('pick', getWeekStartDate());
          }
        }, {
          text: '本月第一天',
          onClick(picker) {
            that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getMonthStartDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[0] = {
              key: 'monthStart',
              value: '本月第一天',
              date: getMonthStartDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[0] == false) {
              that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
            }

            // that.findSelsectChanged('shortCut')
            picker.$emit('pick', getMonthStartDate());
          }
        }, {
          text: '本季第一天',
          onClick(picker) {
            // console.log('本季初 click')
            that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getQuarterStartDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[0] = {
              key: 'quarterStart',
              value: '本季第一天',
              date: getQuarterStartDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[0] == false) {
              that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
            }

            // that.findSelsectChanged('shortCut')
            picker.$emit('pick', getQuarterStartDate());
          }
        }, {
          text: '本年第一天',
          onClick(picker) {
            that.isShortCut[0] = that.accu_start_end_date_dynamic[0].date === getYearStartDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[0] = {
              key: 'yearStart',
              value: '本年第一天',
              date: getYearStartDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[0] == false) {
              that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
            }

            // that.findSelsectChanged('shortCut')
            picker.$emit('pick', getYearStartDate());
          }
        }
        , {
          text: '2018-01-01',
          onClick(picker) {
            that.isShortCut[0] = false
            that.accu_start_end_date_dynamic[0] = {key: 'normal', value: '', date: ''}
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[0] == false) {
              that.lastSelectDates[0] = {...that.accu_start_end_date_dynamic[0]}
            }

            // that.findSelsectChanged('shortCut')
            picker.$emit('pick', '');
          }
        }
      ]
    }

    this.pickerOptionsEnd = {
      //禁用第一个日期选择过的日期前面所有日期
      disabledDate(time) {
        return (time.getTime() + 86400*1000 < new Date(that.accu_start_end_date[0]) || time.getTime() + 86400*1000 < new Date('2021-01-01') )
      },
      shortcuts: [
        {
          text: '上周最后一天',
          onClick(picker) {
            //如果点击前后日期相同，不会触发日期的update函数
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getLastWeekEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'lastWeekEnd',
              value: '上周最后一天',
              date: getLastWeekEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }


            // that.findSelsectChanged('shortCutLast')
            //+new Date().format('yyyy-mm-dd')
            picker.$emit('pick', getLastWeekEndDate());
          }
        },
        {
          text: '上月最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getLastMonthEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'lastMonthEnd',
              value: '上月最后一天',
              date: getLastMonthEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            // that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getLastMonthEndDate());
          }
        }, {
          text: '上季最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getLastQuarterEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'lastQuarterEnd',
              value: '上季最后一天',
              date: getLastQuarterEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            // that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getLastQuarterEndDate());
          }
        }, {
          text: '上年最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getLastYearEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'lastYearEnd',
              value: '上年最后一天',
              date: getLastYearEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            // that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getLastYearEndDate());
          }
        },
        {
          text: '本周最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getWeekEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'weekEnd',
              value: '本周最后一天',
              date: getWeekEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            // that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getWeekEndDate());
          }
        },
        {
          text: '本月最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getMonthEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'monthEnd',
              value: '本月最后一天',
              date: getMonthEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            // that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getMonthEndDate());
          }
        },
        {
          text: '本季最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getQuarterEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'quarterEnd',
              value: '本季最后一天',
              date: getQuarterEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            // that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getQuarterEndDate());
          }
        },
        {
          text: '本年最后一天',
          onClick(picker) {
            that.isShortCut[1] = that.accu_start_end_date_dynamic[1].date === getYearEndDate().format('yyyy-MM-dd') ? false : true
            that.accu_start_end_date_dynamic[1] = {
              key: 'yearEnd',
              value: '本年最后一天',
              date: getYearEndDate().format('yyyy-MM-dd')
            }
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            // that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', getYearEndDate());
          }
        }, {
          text: '今天',
          onClick(picker) {
            that.isShortCut[1] = false
            that.accu_start_end_date_dynamic[1] = {key: 'normal', value: '', date: ''}
            that.accu_start_end_date_dynamic = JSON.parse(JSON.stringify(that.accu_start_end_date_dynamic))
            if (that.isShortCut[1] == false) {
              that.lastSelectDates[1] = {...that.accu_start_end_date_dynamic[1]}
            }

            // that.findSelsectChanged('shortCutLast')
            picker.$emit('pick', '');
          }
        }]
    }
  },
  watch:{
    accu_start_end_date(newVal) {
      // console.log('accu_start_end_date',newVal)
      let oldVal = this.lastSelectDates
      // console.log('check-----------------\n', newVal[0], oldVal[0].date)
      if (newVal[0] != oldVal[0].date) {
        if (this.isShortCut[0] == true) {
          // console.log('this.isShortCut[0]', this.isShortCut[0])

          this.isShortCut[0] = false
          this.lastSelectDates[0] = {...this.accu_start_end_date_dynamic[0]}
          // console.log("accu_start_end_date/shortCut", this.accu_start_end_date_dynamic)
        } else {
          // console.log("accu_start_end_date/nomal", [...newVal])
          this.accu_start_end_date_dynamic[0] = {key: 'normal', value: newVal[0], date: newVal[0]}
          this.lastSelectDates[0] = {...this.accu_start_end_date_dynamic[0]}
          // console.log('this.lastSelectDates[0]', this.lastSelectDates[0])
        }
      } else if (newVal[1] != oldVal[1].date) {
        if (this.isShortCut[1] == true) {
          // console.log('this.isShortCut[1]', this.isShortCut[1])

          this.isShortCut[1] = false
          this.lastSelectDates[1] = {...this.accu_start_end_date_dynamic[1]}
          // console.log("accu_start_end_date/shortCut", this.accu_start_end_date_dynamic)
        } else {
          // console.log("accu_start_end_date/nomal2", [...newVal])
          this.accu_start_end_date_dynamic[1] = {key: 'normal', value: newVal[1], date: newVal[1]}
          // console.log('this.accu_start_end_date_dynamic[1]',this.accu_start_end_date_dynamic[1])
          this.lastSelectDates[1] = {...this.accu_start_end_date_dynamic[1]}
        }
      } else if (newVal[0] == oldVal[0].date) {
        //日期相同，但是是从动态日期点击到不动态日期
        // console.log('newVal[0]==oldVal[0].date',newVal[0],oldVal[0])

      }


      // this.querySummaryPageData()
      // console.log('this.accu_start_end_date_dynamic最新值',this.accu_start_end_date_dynamic,this.accu_start_end_date)
      // this.findSelsectChanged('accu_start_end_date_change')
      this.$emit("dateAreaChange",this.accu_start_end_date_dynamic)
    },
    defaultStart(newVal) {
      if (!newVal) {
        // 重置功能修复
        this.accu_start_end_date_dynamic[0].value = ''
        this.accu_start_end_date[0] = ''
        this.$forceUpdate()
      }
    },
    defaultEnd(newVal) {
      if (!newVal) {
        // 重置功能修复
        this.accu_start_end_date_dynamic[1].value = ''
        this.accu_start_end_date[1] = ''
        this.$forceUpdate()
      }
    }
  },
  methods:{
    //-----------时间
    openStartPicker() {
      // console.log('openStartPicker',this.$refs.startDatePicker)
      this.$refs.startDatePicker.pickerVisible = true
    },

    openEndPicker() {
      // console.log('openEndPicker')
      this.$refs.endDatePicker.pickerVisible = true
    },
  }
}
</script>

<style scoped>

</style>
